module.exports = __webpack_public_path__ + "static/UJECIE1v3-e72da997f3d89602f1dce88bb8363391.jpg";